import i18n from "i18next";
import { useEffect } from "react";
import { initReactI18next } from "react-i18next";

import { en } from "./translations/en";
import { fr } from "./translations/fr";
import { useLanguage } from "./useLanguage";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  lng: "en",
  resources: {
    en,
    fr,
  },
});

export const useI18n: VoidFunction = () => {
  const [language] = useLanguage();
  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);
};
